const firstDayOfGen3 = new Date(2013, 0, 1);


// this is not the actual date, but close enough for
// my results
const firstDayOfNewRelayRules = new Date(2011, 3, 1);

const firstDayOfGen5 = new Date(2021, 8, 1);

function decimalPlaces(date) {
    return date > firstDayOfGen3 ? 3 : 2;
}

function formatTimeBasedOnDate(value, record) {
    if (typeof value !== "number")
        return value;

    return value.toFixed(decimalPlaces(record.date));
}

export { formatTimeBasedOnDate, firstDayOfNewRelayRules, firstDayOfGen5 }